<template>
  <div id="app" class="min-h-screen bg-black text-white">
    <!-- Navbar -->
    <nav class="bg-capoeira-700 text-white shadow-lg">
      <div class="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <router-link to="/" class="text-2xl font-bold">
          🥁 Capoeira Torneo
        </router-link>

        <div class="flex gap-4">
          <router-link
            to="/admin"
            class="hover:bg-capoeira-600 px-4 py-2 rounded transition"
          >
            Admin
          </router-link>
          <router-link
            to="/jueces"
            class="hover:bg-capoeira-600 px-4 py-2 rounded transition"
          >
            Jueces
          </router-link>
          <router-link
            to="/public"
            class="hover:bg-capoeira-600 px-4 py-2 rounded transition"
          >
            Resumen
          </router-link>
                    <router-link
            to="/public/pantallas"
            class="hover:bg-capoeira-600 px-4 py-2 rounded transition"
          >
            Pantallas
          </router-link>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="max-w-7xl mx-auto px-4 py-8">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" :key="$route.fullPath" />
        </transition>
      </router-view>
    </main>

    <!-- Footer -->
    <footer class="bg-gray-800 text-white text-center py-6 mt-12">
      <p>&copy; 2024 Sistema de Torneo de Capoeira. Todos los derechos reservados.</p>
    </footer>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
